import { TTBFraudStatus } from '../../types/tryThenBuyFraud';

export const TTB_FRAUD_FILTER_STATUS = [
  {
    text: 'Initialized',
    value: TTBFraudStatus.INITIALIZED,
  },
  {
    text: 'Trial Coming',
    value: TTBFraudStatus.TRIAL_COMING,
  },
  {
    text: 'Trial Started',
    value: TTBFraudStatus.TRIAL_STARTED,
  },
  {
    text: 'Trial Half Done',
    value: TTBFraudStatus.TRIAL_HALF_DONE,
  },
  {
    text: '2 Days Left in Trial',
    value: TTBFraudStatus.TRIAL_2_DAYS_LEFT,
  },
  {
    text: '1 Day Left in Trial',
    value: TTBFraudStatus.TRIAL_1_DAY_LEFT,
  },
  {
    text: 'Time To Decide',
    value: TTBFraudStatus.TIME_TO_DECIDE,
  },
  {
    text: 'Last Chance',
    value: TTBFraudStatus.LAST_CHANCE,
  },
  {
    text: 'Product Returning',
    value: TTBFraudStatus.PRODUCT_RETURNING,
  },
  {
    text: 'Product Picked Up',
    value: TTBFraudStatus.PRODUCT_PICKED_UP,
  },
  {
    text: 'Product Returned',
    value: TTBFraudStatus.PRODUCT_RETURNED,
  },
  {
    text: 'Product Received',
    value: TTBFraudStatus.PRODUCT_RECEIVED,
  },
  {
    text: 'Bought',
    value: TTBFraudStatus.BOUGHT,
  },
  {
    text: 'Cancelled',
    value: TTBFraudStatus.CANCELLED,
  },
  {
    text: 'Charged',
    value: TTBFraudStatus.CHARGED,
  },
  {
    text: 'Mismatched Component',
    value: TTBFraudStatus.MISMATCHED_COMPONENT,
  },
  {
    text: 'Mismatched Component Return Picked Up',
    value: TTBFraudStatus.MISMATCHED_COMPONENT_RETURN_PICKED_UP,
  },
  {
    text: 'Mismatched Component Return Received',
    value: TTBFraudStatus.MISMATCHED_COMPONENT_RETURN_RECEIVED,
  },
  {
    text: 'Product Returning To TM',
    value: TTBFraudStatus.PRODUCT_RETURNING_TO_TM,
  },
  {
    text: 'Product Received By TM',
    value: TTBFraudStatus.PRODUCT_RECEIVED_TO_TM,
  },
  {
    text: 'One Week Left To Forced Charge',
    value: TTBFraudStatus.ONE_WEEK_LEFT_TO_FORCED_CHARGE,
  },
];
